
const AssetManagementActiveIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.875 4.375V3.75C6.875 2.71447 7.71447 1.875 8.75 1.875H11.25C12.2855 1.875 13.125 2.71447 13.125 3.75V4.375H16.25C17.2855 4.375 18.125 5.21447 18.125 6.25V9.46228C15.6788 10.7321 12.9163 11.4544 10 11.4544C7.08367 11.4544 4.32125 10.7321 1.875 9.46228V6.25C1.875 5.21447 2.71447 4.375 3.75 4.375H6.875ZM8.125 3.75C8.125 3.40482 8.40482 3.125 8.75 3.125H11.25C11.5952 3.125 11.875 3.40482 11.875 3.75V4.375H8.125V3.75Z"
      fill="currentColor"
    />
    <path
      d="M9.375 10.625V10C9.375 9.65482 9.65482 9.375 10 9.375C10.3452 9.375 10.625 9.65482 10.625 10V10.625C13.4044 10.5722 16.0367 9.87018 18.125 8.68228V15.625C18.125 16.6605 17.2855 17.5 16.25 17.5H3.75C2.71447 17.5 1.875 16.6605 1.875 15.625V8.68228C3.96334 9.87018 6.59563 10.5722 9.375 10.625Z"
      fill="currentColor"
    />
  </svg>
)

export default AssetManagementActiveIcon
